<style>
  .search-table-outter { overflow-x: scroll; }
  
  </style>

<div class="col-md-12">
  <h3 class="">Report - Accrual Calculation</h3>
  <hr style="margin: 0;border: lightgray solid 0.5px; ">
<br />
<div class="panel panel-primary">
  <div class="panel-heading">Search Information</div>
  <div class="panel-body">
         <form *ngIf="user.Role=='Admin'|| user.Role == 'ReadOnly'" name="form" (ngSubmit)="getDropAnanlysis('search')" #f="ngForm" >
        <div class="form">
            <div class="form-group row">
                <label for="UserCai" class="col-sm-2 col-form-label">Employee Name:</label>
                <div class="col-sm-4">
                  {{user.Name}}
                </div>
              </div>
          <div class="form-group row">
                    <label for="SupplierNamelbl"  class="col-sm-2 col-form-label">Supplier AB#</label>
            <div class="col-sm-4">
              <input placeholder="All" name="SupplierNamelbl" id="SupplierNamelbl" type="text" class="form-control" [(ngModel)]="SupplierAB" [ngbTypeahead]="searchSupplier"/>         
             </div>
         
            <label for="ObjectAccountlbl" class="col-sm-2 col-form-label">Object Account:</label>
            <div class="col-sm-4">
              <input placeholder="All" name="ObjectAccountlbl" id="ObjectAccountlbl" type="text" class="form-control" [(ngModel)]="ObjectAccount" [ngbTypeahead]="searchObjectAcnt"/>
            </div>
          </div>
          <div class="form-group row">
            <label for="Arealbl1" class="col-sm-2 col-form-label">Area:</label>
            <div class="col-sm-4">
             
              <input placeholder="All" name="Arealbl1" id="Arealbl1" type="text" class="form-control" [(ngModel)]="Area" [ngbTypeahead]="searchArea"/>
            </div>
       
            <label for="Departmentlbl1" class="col-sm-2 col-form-label">Department:</label>
            <div class="col-sm-4">
             
              <input placeholder="All" name="Departmentlbl1" id="Departmentlbl1" type="text" class="form-control" [(ngModel)]="Department" [ngbTypeahead]="searchDepartment"/>
            </div>
          </div> 
              <div class="form-group row">
                <label for="FromDate" class="col-sm-2 col-form-label">Service From Date:</label>
                  <div class="col-sm-3">
                    <input class="form-control" 
                    name="dpFrom" id="FromDate" [(ngModel)]="FrmDt" ngbDatepicker #d="ngbDatepicker" #dpFrom="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpFrom.invalid }" required> 
                    <div *ngIf="f.submitted && dpFrom.invalid" class="invalid-feedback invalid-display">
                      <div *ngIf="dpFrom.errors?.['required']">*From date is required</div>
                    </div>
                  </div>
                   <div class="col-sm-1" style="padding-left: 0px;">
                      <button class="glyphicon glyphicon-calendar" (click)="d.toggle()" type="button"></button>
                   </div>
                   
            </div>
            <div class="form-group row">
                <label for="ToDate" class="col-sm-2 col-form-label">Service To Date:</label>
                   <div class="col-sm-3">
                    <input class="form-control" 
                    name="dpTo" id="ToDate" [(ngModel)]="ToDt" ngbDatepicker #dt="ngbDatepicker" #dpTo="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpTo.invalid }" required> 
                    <div *ngIf="f.submitted && dpTo.invalid" class="invalid-feedback invalid-display">
                      <div *ngIf="dpTo.errors?.['required']">*To date is required</div>
                    </div>
                  </div>
                   <div class="col-sm-1" style="padding-left: 0px;">
                      <button class="glyphicon glyphicon-calendar" (click)="dt.toggle()" type="button"></button>
                   </div>
                   
            </div>
            <div class="form-group row">
              <label for="ApprDt" class="col-sm-2 col-form-label">Compliance Approved Date:</label>
                 <div class="col-sm-3">
                  <input class="form-control" 
                  name="dpAppr" id="ApprDt" [(ngModel)]="ApprDt" ngbDatepicker #dtt="ngbDatepicker" #dpAppr="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpAppr.invalid }" required> 
                  <div *ngIf="f.submitted && dpAppr.invalid" class="invalid-feedback invalid-display">
                    <div *ngIf="dpAppr.errors?.['required']">*Approved date is required</div>
                  </div>
                </div>
                 <div class="col-sm-1" style="padding-left: 0px;">
                    <button class="glyphicon glyphicon-calendar" (click)="dtt.toggle()" type="button"></button>
                 </div>
                 
          </div>
          <div class="form-group row">
            <div class="col-sm-2 col-form-label"></div>
            <div class="col-sm-4">
                <button class="btn btn-primary"  >Search</button>
            </div>
          </div>
        </div>
      </form>

      <form *ngIf ="user.Role == 'EndUser'" name="form" (ngSubmit)="f.form.valid && getDropAnanlysis('search')" #f="ngForm"  novalidate>
        <div class="form">
            <div class="form-group row">
                <label for="UserCai" class="col-sm-2 col-form-label">Employee Name:</label>
                <div class="col-sm-4">
                  {{user.Name}}
                </div>
              </div>
          
          <div class="form-group row">
                    <label for="userSupplierNo"  class="col-sm-2 col-form-label">Supplier AB#</label>
            <div class="col-sm-4">
              <input placeholder="All" name="userSupplierNo" id="userSupplierNo" type="text" class="form-control" [(ngModel)]="SupplierAB" [ngbTypeahead]="searchSupplier" #Supplier="ngModel" [ngClass]="{ 'is-invalid': f.submitted && Supplier.invalid }" required/>              
                <div *ngIf="f.submitted && Supplier.invalid" class="invalid-feedback invalid-display">
                  <div *ngIf="Supplier.errors?.['required']">Supplier is required</div>
              </div>
             </div>
       
            <label for="userObjectAccountlbl" class="col-sm-2 col-form-label">Object Account:</label>
            <div class="col-sm-4">
              <input placeholder="All" name="userObjectAccountlbl" id="userObjectAccountlbl" type="text" class="form-control" [(ngModel)]="ObjectAccount" [ngbTypeahead]="searchObjectAcnt"  #ObjectAcc="ngModel" [ngClass]="{ 'is-invalid': f.submitted && ObjectAcc.invalid }" required/>
              <div *ngIf="f.submitted && ObjectAcc.invalid" class="invalid-feedback invalid-display">
                <div *ngIf="ObjectAcc.errors?.['required']">Object account is required</div>
            </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="Arealbl1" class="col-sm-2 col-form-label">Area:</label>
            <div class="col-sm-4">
             
              <input placeholder="All" name="Arealbl1" id="Arealbl1" type="text" class="form-control" [(ngModel)]="Area" [ngbTypeahead]="searchArea"/>
            </div>
         
            <label for="Departmentlbl1" class="col-sm-2 col-form-label">Department:</label>
            <div class="col-sm-4">
             
              <input placeholder="All" name="Departmentlbl1" id="Departmentlbl1" type="text" class="form-control" [(ngModel)]="Department" [ngbTypeahead]="searchDepartment"/>
            </div>
          </div> 
              <div class="form-group row">
                <label for="userFromDate" class="col-sm-2 col-form-label">From Date:</label>
                  <div class="col-sm-3">
                    <input class="form-control" placeholder="dd-mm-yyyy"
                    name="userFromDate" id="userFromDate" [(ngModel)]="FrmDt" ngbDatepicker #d="ngbDatepicker" #dpFrom="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpFrom.invalid }" required> 
                    <div *ngIf="f.submitted && dpFrom.invalid" class="invalid-feedback invalid-display">
                      <div *ngIf="dpFrom.errors?.['required']">*From date is required</div>
                    </div>
                  </div>
                   <div class="col-sm-1" style="padding-left: 0px;">
                      <button class="glyphicon glyphicon-calendar" (click)="d.toggle()" type="button"></button>
                   </div>
                   
            </div>
            <div class="form-group row">
                <label for="userToDate" class="col-sm-2 col-form-label">To Date:</label>
                   <div class="col-sm-3">
                    <input class="form-control" placeholder="dd-mm-yyyy"
                    name="userToDate" id="userToDate" [(ngModel)]="ToDt" ngbDatepicker #dt="ngbDatepicker" #dpTo="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpTo.invalid }" required> 
                    <div *ngIf="f.submitted && dpTo.invalid" class="invalid-feedback invalid-display">
                      <div *ngIf="dpTo.errors?.['required']">*To date is required</div>
                    </div>
                  </div>
                   <div class="col-sm-1" style="padding-left: 0px;">
                      <button class="glyphicon glyphicon-calendar" (click)="dt.toggle()" type="button"></button>
                   </div>
                   
            </div>
            <div class="form-group row">
              <label for="userApprDt" class="col-sm-2 col-form-label">Compliance Approved Date:</label>
                 <div class="col-sm-3">
                  <input class="form-control" 
                  name="userApprDt" id="userApprDt" disabled [(ngModel)]="ApprDt" ngbDatepicker #dtt="ngbDatepicker" #dpAppr="ngModel"  [ngClass]="{ 'is-invalid': f.submitted && dpAppr.invalid }" required> 
                  <div *ngIf="f.submitted && dpAppr.invalid" class="invalid-feedback invalid-display">
                    <div *ngIf="dpAppr.errors?.['required']">*Approved date is required</div>
                  </div>
                </div>
                
                 
          </div>
          <div class="form-group row">
            <div class="col-sm-2 col-form-label"></div>
            <div class="col-sm-4">
              <button class="btn btn-primary"  >Search</button>
            </div>
          </div>
        </div>
      </form>
  <div class="clearfix"></div>
</div>
</div>
  <br /> <br />
  
  <div class="form-group row" *ngIf="dropAnalysisResult.length > 0">      
    <div class="col-md-12">              
    <div class="col-sm-2 col-form-label"><input type="radio" name="1" id="rbdrop" style="margin:5px;" class="with-gap" checked (click)="EnableText()" [value]="0">Enter Drop</div>
    <div class="col-sm-3">
        <input type="text" numeric numericType="decimal" [disabled] = "Droptxt"   [(ngModel)]="Drop"  placeholder="0.00" name="Drop" class="form-control"
        id="Drop">
      </div>
      <div class="col-sm-2 col-form-label">Enter Drop Comments</div>
      <div class="col-sm-3"> 
          <textarea style="margin: 0px; height: 84px; width: 276px;" [(ngModel)]="DropComments"  ></textarea>
          <div *ngIf="errDropCmt" class="invalid-feedback invalid-display">
              <div >Atleast 20 character required for drop comment</div>
          </div>
      </div>
      <div class="col-sm-2">
          <button class="btn btn-primary" (click)="getDropAnanlysis('calc')" >Calculate Drops</button>
        </div></div>
    <div class="col-md-12"> 
        <div class="col-sm-2 col-form-label"><input type="radio" name="1" id="rbadjust" class="with-gap" style="margin:5px;" [(ngModel)]="flag" (click)="EnableText()"  [value]="1" >Enter Adjustment</div>
        <div class="col-sm-3">
          <input type="text" numeric numericType="decimal" [disabled] = "Adjustmentxt"   [(ngModel)]="Adjust"  placeholder="0.00" name="Adjustment" class="form-control"
          id="Adjustment">
        </div>
        </div>   

</div>
  
  <div class="search-table-outter" *ngIf="dropAnalysisResult.length > 0">
  <table class="table table-bordered" width=100%>
    <col style="width:30%">
 
    <thead>
      <tr>
          <th scope="col" > Select <input type="checkbox" [(ngModel)]="ChkAll" (change)="selectedAll(ChkAll)" /></th>
          <th scope="col" >Provisioning ID</th>
          <th scope="col">Supplier AB#</th>
          <th scope="col">Supplier Name</th>
         <th scope="col" >Object Account</th>
          <th scope="col" >Month/Year</th>
          <th scope="col" >Cost Center</th>
          <th scope="col" >Division Field</th> 
          <th scope="col" >Company Code</th> 
          <th scope="col" >Area</th>
          <th scope="col" >Department</th>
      
          <th scope="col" >VOWD Amount</th>
          <th scope="col" >Invoice</th>
          <th scope="col" >Adjustment</th>
          <th scope="col" >Drops</th>
          <th scope="col" >Overpayments</th>
          <th scope="col" >Accrual</th>
         
      </tr>
    </thead>
    <tbody>
      
          <tr *ngFor="let _dropres of dropAnalysisResult | paginate: config">
        <td><input type="checkbox" [(ngModel)]="_dropres.selected"  ></td> 
        <td title="CAI">{{ _dropres.CreatedBy }}</td>
        <td title="Supplier AB#">{{ _dropres.SupplierAB }}</td>
        <td title="Supplier Name">{{ _dropres.SupplierName }}</td>
        <td title="Object Account">{{ _dropres.ObjDescr }}</td>
        <td title="Month/Year">{{ _dropres.Period }}</td>
        <td title="Cost Center">{{ _dropres.CostCenter }}</td>
       
         <td title="Division Field">{{ _dropres.DivisionField }}</td> 
         <td title="Company Code">{{ _dropres.CompanyCode }}</td>
        <td title="Area Details" >{{ _dropres.Area_Code}}-{{ _dropres.Area_description}}</td>
        <td title="Department">{{ _dropres.Division }}</td>
        
        <td title="VoWD Amount">{{ _dropres.VOWDAmount| currency }}</td>
        <td title="Invoice">{{ _dropres.Invoice | currency}}</td>
        <td title="Adjustment">{{ _dropres.Adjustment | currency}}</td>
        <td title="Drops">{{ ConvertToInt(_dropres.Drops) | currency}}</td>
    
          <td title="OverPayments">{{ _dropres.Overpayments | currency}}</td>
          <td title="Accrual">{{ _dropres.Accrual| currency }}</td>
      </tr>
    </tbody>
<tfoot>
  <td colspan="11" style="font-weight: bold;text-align: right;">Total Sum:</td>
  <td style="font-weight: bold;">{{vowdTotal| currency}}</td>
  <td style="font-weight: bold;">{{vowdInv| currency}}</td>
  <td style="font-weight: bold;">{{vowdAdj| currency}}</td>
  <td style="font-weight: bold;">{{vowdDrp| currency}}</td>
  <td style="font-weight: bold;">{{vowdOvp| currency}}</td>
  <td style="font-weight: bold;">{{vowdAccr| currency}}</td>
</tfoot>
  </table>
  <pagination-controls *ngIf="dropAnalysisResult.length > 0" (pageChange)="pageChanged($event)"></pagination-controls>
   </div> 
   <br>
  <div class="form-group row" *ngIf="dropAnalysisResult.length > 0">

    <div class="col-sm-4">
    <button class="btn btn-primary " (click)="OnSubmit()" [disabled]="flgLock" [disabled]="user.Role=='ReadOnly'">Save Report</button>&nbsp;
    <button (click)="ExportTOExcel()" class="btn btn-primary">ExportTOExcel</button>  
    </div>
  </div>  

</div>

<table class="table table-bordered hidden" id="reportGrid_all">
  <col style="width:30%">
  <thead>
    <tr>
        <th scope="col" >Provisioning ID</th>
        <th scope="col">Supplier AB#</th>
        <th scope="col">Supplier Name</th>
        <th scope="col" >Object Account</th>
        <th scope="col" >Month/Year</th>
        <th scope="col" >Cost Center</th>
       <th scope="col" >Division Field</th> 
       <th scope="col" >Company Code</th> 
       <th scope="col" > Area</th>
       <th scope="col" >Department</th>
        <th scope="col" >VOWD Amount</th>
        <th scope="col" >Invoice</th>
        <th scope="col" >Adjustment</th>
        <th scope="col" >Drops</th>
        <th scope="col" >Overpayments</th>
        <th scope="col" >Accrual</th>
       
    </tr>
  </thead>
  <tbody>
       <tr *ngFor="let _dropres of dropAnalysisResult">
       <td title="CAI">{{ _dropres.CreatedBy }}</td>
      <td title="Supplier AB#">{{ _dropres.SupplierAB }}</td>
      <td title="Supplier Name">{{ _dropres.SupplierName }}</td>
      <td title="Object Account">{{ _dropres.ObjDescr }}</td>
      <td title="Month/Year">{{ _dropres.Period }}</td>
      <td title="Cost Center">{{ _dropres.CostCenter }}</td>
      <td title="Division Field">{{ _dropres.DivisionField }}</td> 
      <td title="Company Code">{{ _dropres.CompanyCode }}</td>
      <td title="Area Details">{{ _dropres.Area_Code}}-{{ _dropres.Area_description}}</td>
      <td title="Department">{{ _dropres.Division}}</td>
      <td title="VoWD Amount">{{ _dropres.VOWDAmount| currency }}</td>
      <td title="Invoice">{{ _dropres.Invoice | currency}}</td>
      <td title="Adjustment">{{ _dropres.Adjustment | currency}}</td>
      <td title="Drops">{{ _dropres.Drops | currency}}</td>
        <td title="OverPayments">{{ _dropres.Overpayments | currency}}</td>
        <td title="Accrual">{{ _dropres.Accrual| currency }}</td>
    </tr>
  </tbody>
</table>